import { ar, de, enUS, es, fr, pt } from 'date-fns/locale';
import { getLocaleSuffix } from './localizedName';

const DATE_FNS_LOCALES = { en: enUS, fr, ar, de, es, pt };

// Locale date-fns correspondant à la langue choisie dans l'app.
export const getDateFnsLocale = (language) => DATE_FNS_LOCALES[getLocaleSuffix(language)];

export default getDateFnsLocale;
